<div id="multiBuildingModal" class="modal fade" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <span>Seleziona un civico</span>
                <button type="button" class="close" aria-label="Close" data-dismiss="modal" (click)="dismissModal.emit(end)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- <ng-container *ngIf="buildings && buildings.length && !wait"> -->
                    <ng-container *ngFor="let b of buildings" class="d-flex flex-column justify-content-center align-items-center">
                        <button mat-stroked-button (click)="selectBuilding.emit({building: b, end: end})" class="w-100 my-2">
                            {{b.building_labels[0]}}
                        </button>
                    </ng-container>
                <!-- </ng-container>
                <ng-container *ngIf="wait">
                    <mat-spinner [diameter]="30" class="mx-auto"></mat-spinner>
                </ng-container> -->
            </div>
        </div>
    </div>
</div>